

















import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
import { MswAppTitle } from '@/shared/msw-app-title';
const cssPrefix = 'flexSpendOld';

@Component({
  components: {
    MswAppTitle,
  },
})
export default class FlexspendOld extends SwExtendedVue {
  cssPrefix = cssPrefix;
  sessionId :any = JSON.parse(this.$store.getters.getUserInfo).user.sessionId;
  userId: any = this.$store.getters.getUserId;
  flexspendURL: string = `${window.location.origin}/flexspend/flexspendextnew.aspx?mode=APP&I=${btoa(this.sessionId)}`;

  // launchWifiPlanner() {
  //   console.warn('wifi planner');
  //   const url = `${envCongif.api_url}/partnerappsToken?username=${this.userId}&appName=WIFIPLANNER&sessionID=${this.sessionId}&qsparams=`;
  //   window.open(url, '_blank');
  // }
}
